console.log(1111,'console')
if (window?.location?.href?.includes('vconsole=show')) {
        // VConsole() 在此假设已经加载完毕，因为所有 defer 脚本将按顺序执行
        // eslint-disable-next-line no-new
        var vConsole = new VConsole();
    }